/* Maps each step.kind to the component that renders its answer controls —
   replaces the old giant switch. Adding a step = add a file + one line here.
   welcome/intro have no controls, so they're absent (StepControls → null). */
import { FC } from 'react';
import { Step, StepKind } from '../flow';
import { EventCodeStep } from './EventCodeStep';
import { IdentityStep } from './IdentityStep';
import { GroupStep } from './GroupStep';
import { SessionStep } from './SessionStep';
import { ChoiceStep } from './ChoiceStep';
import { ScaleStep } from './ScaleStep';
import { HabitStep } from './HabitStep';
import { KidsStep } from './KidsStep';
import { KidsAgesStep } from './KidsAgesStep';
import { PetsStep } from './PetsStep';
import { ScoreStep } from './ScoreReveal';
import { CareerPicker } from './CareerPicker';
import { ReviewStep } from './ReviewStep';

const REGISTRY: Partial<Record<StepKind, FC<{ step: Step }>>> = {
  eventCode: EventCodeStep,
  identity: IdentityStep,
  group: GroupStep,
  session: SessionStep,
  choice: ChoiceStep,
  scale: ScaleStep,
  habit: HabitStep,
  kids: KidsStep,
  kidsAges: KidsAgesStep,
  pets: PetsStep,
  score: ScoreStep,
  careerPick: CareerPicker,
  review: ReviewStep,
};

export function StepControls({ step }: { step: Step }) {
  const C = REGISTRY[step.kind];
  return C ? <C step={step} /> : null;
}
